<template>
  <div class="product_info_card">
    <div>
      <div class="product_img">
        <div @click="closeCard">
          <img
            class="close-icon"
            src="https://cdn.shopify.com/s/files/1/1000/3130/files/Group_40.png?v=1686811621"
            alt="error"
            @click="$emit('close')"
          />
        </div>
        <a :href="productData.productUrl">
          <img v-lazy="productData.productidImage" class="productImage" />
        </a>
      </div>
      <h2 class="subtitle">
        {{ productData.productTitle }}
      </h2>

      <div class="subtitle_b">
        <div class="card-title bold product_price">
          <span v-if="Number(productData.productComparePrice) > 0">
            {{ formattedPrice }}
            <del>
              {{ formattedComparePrice }}
            </del>
          </span>
          <span v-else>
            {{ formattedPrice }}
          </span>
        </div>
      </div>
    </div>

    <div class="product_cta">
      <template v-if="productData.productQuantity === '0'">
        <button type="button" aria-label="Sold Out" class="cta_btn sold-out">SOLD OUT</button>
      </template>
      <template v-else>
        <a :href="productData.productUrl" class="cta_btn view_btn" aria-label="View Product">
          VIEW
        </a>
        <button
          id="AddToCart"
          type="submit"
          class="cta_btn cta-modifier"
          aria-label="Quick Add"
          :variantid="productData.productVariantid"
          @click="addToCard"
        >
          QUICK ADD
          <div class="loader_tmb">
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
        </button>
      </template>
    </div>
  </div>
</template>
<script>
import { ShopifyAPI } from '@/vue/Shopify/Shopify';
import { currencyJson } from '@/currency';

export default {
  name: 'ProductPopup',
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
    };
  },
  computed: {
    formattedPrice() {
      const price =
        this.currencySymbol === '€'
          ? Number(this.productData.productidPrice.toString().replace(',', '.')).toFixed(2)
          : this.productData.productidPrice;

      return this.currencySymbol + ' ' + price;
    },

    formattedComparePrice() {
      const price =
        this.currencySymbol === '€'
          ? Number(this.productData.productComparePrice.toString().replace(',', '.')).toFixed(2)
          : this.productData.productComparePrice;

      return this.currencySymbol + ' ' + price;
    },
  },
  mounted() {
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
  },

  methods: {
    async addToCard(event) {
      // var addToCartCta = document.querySelectorAll('.cta_btn.cta-modifier').classList.add('active');

      // for(let i of  addToCartCta){

      // }
      event.target.classList.add('active');

      try {
        let product;
        if (event.target.tagName === 'SPAN') {
          product = event.target.parentNode;
        } else {
          product = event.target;
        }

        const variant = product.getAttribute('variantid');
        // console.log('Variant ID:', variant);
        if (!variant) {
          console.error('No variant ID found for product');
          return;
        }

        const dynamic = new ShopifyAPI();

        const item = {
          id: variant,
          qty: 1,
        };
        await dynamic.addItem(item);
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        setTimeout(() => {
          event.target.classList.remove('active');
        }, 2000);
      }
    },

    toggle_selection_for() {
      this.$store.dispatch('my-module/toggle');
    },
    closeCard(e) {
      if (window.innerWidth <= 768) {
        e.target.closest('.product_card_wrapper').classList.toggle('show');
      }
    },
  },
};
</script>

<style scoped>
.product_info_card {
  padding: 10px 12px;
  border: 1px solid #000;
  background-color: #ffffff;
  max-width: 240px;
}
.subtitle_b {
  margin-bottom: 23px;
}
.subtitle {
  margin: 6px 0 5px;
}
.product_cta {
  display: flex;
  align-items: center;
  gap: 3px;
}
.product_cta .cta_btn {
  width: 50%;
  padding: 7px;
  background: #fff;
  color: #000;
  text-align: center;
  font-size: 10px;
  line-height: 11px;
  font-weight: 400;
  border: 1px solid #000;
  transition: 0.3s ease;
}

.product_cta .cta_btn:hover {
  background: #000;
  color: #fff;
  border: 1px solid #000;
}
.cta_btn.sold-out {
  width: 100%;
  /* display: none; */
}
.close-icon {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 30px;
  height: 30px;
}
/* Responsive Breakpoints */
@media (min-width: 769px) {
  .close-icon {
    display: none;
  }
}

@media (max-width: 768px) {
  .subtitle_b {
    margin-bottom: 35px;
  }
  .product_info_card {
    height: auto;
  }
}

@media (max-width: 575px) {
  .product_info_card a img {
    /* height: 400px; */
    object-fit: cover;
  }

  .product_info_card {
    padding: 17px;
  }
}
@media (max-width: 480px) {
  .product_info_card a img {
    height: 100%;
  }
  .product_info_card {
    height: 100%;
  }
}
</style>
